import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { ThemeProvider } from 'styled-components';
import React__default from 'react';
import theme from '../../theme/theme.js';

var getTheme = function (mode) { return (__assign(__assign({}, theme), { colors: __assign(__assign({}, theme.colors), theme.colors.modes[mode]) })); };
var YoungThemeProvider = function (_a) {
    var children = _a.children, _b = _a.colorMode, colorMode = _b === void 0 ? "light" : _b;
    var theme = getTheme(colorMode);
    return (React__default.createElement(ThemeProvider, { theme: theme }, children));
};

export { YoungThemeProvider };
//# sourceMappingURL=YoungThemeProvider.js.map
